import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HorseRacingService {
  private cancelPendingRequests$ = new Subject<void>();

  constructor(private http: HttpClient) {}
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  getAllRacesByDate(date, ispmu: boolean = false): Observable<any> {
    this.cancelPendingRequests$.next();
    const url =
      environment.apiUrl +
      `/races/getAllRacesByDate/?datetime=${date}&ispmu=${ispmu}`;
    return this.http
      .get<any>(url, this.httpOptions)
      .pipe(takeUntil(this.cancelPendingRequests$));
  }
  getRaceDetails(data: any): Observable<any> {
    if (!data.raceId) {
      return null;
    }
    const url = environment.apiUrl + `/races/getRaceDetails`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
  getTrackRaces(data): Observable<any> {
    const url = environment.apiUrl + `/races/getTrackRaces`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
  createCoupon(data): Observable<any> {
    const url = environment.apiUrl + `/bets/createCoupon`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
  listCountryTracks(data): Observable<any> {
    const url = environment.apiUrl + `/races/listCountryTracks`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
  getNextBettingOpportunities(): Observable<any> {
    const url = environment.apiUrl + `/races/getNextBettingOpportunities`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getNextPMUOpportunities(): Observable<any> {
    const url = environment.apiUrl + `/races/PMURaces/next`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getQuarteRaces(data: any): Observable<any> {
    const url = environment.apiUrl + `/races/getRacesByBetTypes`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
  getValidBetTypes(): Observable<any> {
    const url = environment.apiUrl + `/bets/getValidBetTypes`;
    return this.http.get<any>(url, this.httpOptions);
  }
  cancelRequests() {
    this.cancelPendingRequests$.next();
  }
  ngOnDestroy() {
    this.cancelPendingRequests$.complete();
  }
}
